(() => {
  const header = document.querySelector("[data-maison-header], .header");
  if (!header || header.dataset.headerReady === "true") return;
  header.dataset.headerReady = "true";

  const toggle = header.querySelector("[data-mobile-menu-toggle]");
  const drawer = header.querySelector("[data-mobile-drawer]");
  const searchDetails = header.querySelector("[data-header-search-details]");
  const desktopMq = window.matchMedia("(min-width: 981px)");
  let lockedScrollY = 0;
  let open = false;

  const forceSolid = header.getAttribute("data-force-solid") === "true";

  const setScrolled = () => {
    if (forceSolid) {
      header.classList.add("scrolled");
      return;
    }
    header.classList.toggle("scrolled", window.scrollY > 8);
  };

  setScrolled();
  if (!forceSolid) {
    window.addEventListener("scroll", setScrolled, { passive: true });
  }

  const lockScroll = () => {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add("header-overlay-open");
    document.body.classList.add("header-overlay-open");
    document.body.style.top = `-${lockedScrollY}px`;
  };

  const unlockScroll = () => {
    document.documentElement.classList.remove("header-overlay-open");
    document.body.classList.remove("header-overlay-open");
    document.body.style.top = "";
    window.scrollTo(0, lockedScrollY);
  };

  const setOpen = (nextOpen) => {
    open = Boolean(nextOpen);
    header.classList.toggle("header--menu-open", open);
    if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (drawer) {
      if (open) {
        drawer.hidden = false;
        drawer.setAttribute("data-open", "true");
      } else {
        drawer.hidden = true;
        drawer.removeAttribute("data-open");
      }
    }
    if (open) lockScroll();
    else unlockScroll();
  };

  const closeMenu = () => setOpen(false);
  const openMenu = () => setOpen(true);
  const toggleMenu = () => setOpen(!open);

  if (toggle) {
    toggle.addEventListener("click", (event) => {
      event.preventDefault();
      toggleMenu();
    });
  }

  if (searchDetails) {
    searchDetails.addEventListener("toggle", () => {
      const searchOpen = searchDetails.hasAttribute("open");
      header.classList.toggle("header--search-open", searchOpen);
      if (searchOpen) {
        if (!open) lockScroll();
      } else if (!open) {
        unlockScroll();
      }
    });
  }

  header.addEventListener("click", (event) => {
    if (event.target.closest("[data-close-mobile-menu]")) {
      event.preventDefault();
      closeMenu();
      return;
    }
    const closeSearch = event.target.closest("[data-close-search]");
    if (closeSearch && searchDetails) {
      event.preventDefault();
      searchDetails.removeAttribute("open");
    }
  });

  if (drawer) {
    drawer.addEventListener("click", (event) => {
      if (event.target === drawer) closeMenu();
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeMenu();
    if (searchDetails && searchDetails.hasAttribute("open")) {
      searchDetails.removeAttribute("open");
    }
  });

  const onViewportChange = () => {
    if (desktopMq.matches) closeMenu();
  };
  if (desktopMq.addEventListener) desktopMq.addEventListener("change", onViewportChange);
  else if (desktopMq.addListener) desktopMq.addListener(onViewportChange);
  window.addEventListener("pageshow", onViewportChange);

  window.addEventListener("ajax-cart", (event) => {
    const count = event.detail && event.detail.item_count;
    if (typeof count === "number") {
      header.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = count;
        el.classList.toggle("is-zero", count < 1);
      });
    }
  });
})();
